import { ErrorResponse, isRouteErrorResponse, useRouteError } from 'react-router';
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { styled } from '@mui/material/styles';

const Main = styled(Container)(() => ({
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  textAlign: 'center',
  verticalAlign: 'middle'
}));

export type RouteError = {
  status: number;
  statusText: string;
};

type Props = {
  error?: RouteError;
};

export default function ErrorPage(props: Readonly<Props>) {
  let error = useRouteError();

  if (props.error) 
    error = props.error;

  function getErrorText(error: unknown): string {
    if (props.error || isRouteErrorResponse(error)) {
      return `${(error as ErrorResponse).status} ${(error as ErrorResponse).statusText}`;
    }
    return `${(error as Error)?.message ?? 'Unknown Error'}`;
  }

  return (
    <Main>
      <Typography variant="h2">{getErrorText(error)}</Typography>
    </Main>
  );
}
